import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Observable, takeWhile, tap } from 'rxjs';
import {
  ExternalPartnerService,
  ExternalPartnerType,
  FirebaseService,
  PartnerDetails
} from '@brightside-web/desktop/data-access/shared';
import { ActivatedRoute, Router } from '@angular/router';
import { Environment } from '@micro-core/environment';
import { BrightsideUiModule } from '@brightside/brightside-ui';
import { MicroUiMoleculeModule } from '@micro-ui/molecule';
import { AsyncPipe, NgIf } from '@angular/common';
import { SharedLegalDocumentsModule } from '@brightside-web/shared/legal-documents';

@Component({
    selector: 'brightside-web-external-lenders-legal',
    imports: [TranslateModule, BrightsideUiModule, MicroUiMoleculeModule, AsyncPipe, NgIf, SharedLegalDocumentsModule],
    templateUrl: './external-lenders-legal.component.html',
    styleUrl: './external-lenders-legal.component.scss'
})
export class ExternalLendersLegalComponent {
  partnerIntro$: Observable<PartnerDetails | undefined> = this._externalPartnerService.currentPartnerDetails$;
  cdnImgUrl: string;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _externalPartnerService: ExternalPartnerService,
    private _env: Environment,
    private _analytics: FirebaseService
  ) {
    this.cdnImgUrl = this._env.cdnUrl + 'images/desktop/';

    this.partnerIntro$
      .pipe(
        takeWhile((partner) => !partner, true),
        tap((partner) => {
          if (partner) {
            this._analytics.logEvent('lender_alternatives_legal_shown');
          }
        })
      )
      .subscribe();

    this._route.paramMap
      .pipe(
        tap((params) => {
          this._externalPartnerService.getPartnerDetails(ExternalPartnerType.LenderAlernatives, params.get('lenderKey') || '');
        })
      )
      .subscribe();
  }

  goToPartnerRedirectUrl(partner: PartnerDetails) {
    this._analytics.logEvent('lender_alternatives_legal_redirect', {
      value: partner.key,
      url: partner.url,
    });
    window.open(partner.url, '_blank');
  }
  //
  // goBackToPartnerList() {
  //   this._router.navigate(['/lender-alternatives']);
  // }
}
